module.exports = " <div class=photo-show> <a class=photo-item v-link=\"{name: 'Search', query: {text: photo.category}}\"> <div class=photo-img> <img v-bind:src=photo.url> </div> <h5>{{photo.title}}</h5> </a> <a class=photo-id v-link=\"{ name: 'PhotoDetail', params: {id: photo.id }}\"> <i class=\"fa fa-camera\"></i> <span>{{photo.id}}</span> </a> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoShow.vue
 ** module id = 72
 ** module chunks = 0
 **/